module.exports = __webpack_public_path__ + "static/media/pk_crash.fb12f247.jpg";